export function validDate(field) {
    const date = field.value;
    let valid = true;

    if (new Date(date) == "Invalid Date") {
        console.log("invalid");
        valid = false;
    }

    return valid;
}
